/**
 * Room-code generation utilities.
 *
 * Codes are 4-char alphanumerics drawn from a curated alphabet that omits
 * visually-confusing characters (0/O, 1/I/L). Uppercase only — easier to
 * read on a TV screen and easier to dictate by voice.
 */

/** Alphabet for room codes. Excludes 0, O, 1, I, L. */
export const CODE_ALPHABET = '23456789ABCDEFGHJKMNPQRSTUVWXYZ'

/** Length (in characters) of a generated room code. */
export const CODE_LENGTH = 4

/** Generate a single random room code. Uniqueness is enforced by callers. */
export function generateRoomCode( length: number = CODE_LENGTH ): string {
  let out = ''
  for ( let i = 0; i < length; i++ ) {
    const idx = Math.floor( Math.random() * CODE_ALPHABET.length )
    out += CODE_ALPHABET[ idx ]
  }
  return out
}

/** Validate that a string looks like a well-formed room code. */
export function isValidRoomCode( code: string ): boolean {
  if ( code.length !== CODE_LENGTH ) return false
  for ( const ch of code ) {
    if ( !CODE_ALPHABET.includes( ch ) ) return false
  }
  return true
}
